import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7caed7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6" }, " ", -1))
const _hoisted_3 = { class: "col-sm-12 col-md-6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label m-0 p-0" }, "ค้นหา:", -1))
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  key: 0,
  class: "card card-empty my-2"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center align-items-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่พบข้อมูล ")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "no-bullets"
}
const _hoisted_11 = { class: "card card-sub my-2" }
const _hoisted_12 = { class: "card-body py-2" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-5 col-lg-3" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "col-sm-7 col-lg-9 info" }
const _hoisted_18 = { class: "list-group list-group-flush" }
const _hoisted_19 = { class: "list-group-item text-truncate" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "list-group-item text-truncate" }
const _hoisted_22 = { class: "list-group-item d-flex justify-content-between align-items-start" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-edit" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 d-sm-inline d-none" }, "แก้ไข", -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_PaginateComponent = _resolveComponent("PaginateComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              "aria-label": "Search",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.keyword) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.filter.keyword,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.display.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.display, (element) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: element.id
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("a", {
                                href: element.url,
                                target: "_blank"
                              }, [
                                _createElementVNode("img", {
                                  src: element.preview,
                                  class: "img-thumbnail d-block w-100 h-100",
                                  alt: `Video ${element.id}`
                                }, null, 8, _hoisted_16)
                              ], 8, _hoisted_15)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("ul", _hoisted_18, [
                                _createElementVNode("li", _hoisted_19, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([{far: !element.pined, fas: element.pined, 'text-warning': element.pined }, "fa-star me-2"]),
                                    style: {"cursor":"pointer"},
                                    onClick: ($event: any) => (_ctx.toggleClick(element.id))
                                  }, null, 10, _hoisted_20),
                                  _createTextVNode(_toDisplayString(element.title), 1)
                                ]),
                                _createElementVNode("li", _hoisted_21, _toDisplayString(element.description), 1),
                                _createElementVNode("li", _hoisted_22, [
                                  _createElementVNode("span", null, "สร้างเมื่อ: " + _toDisplayString(_ctx.thaiDate(element.createdAt)), 1),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary btn-edit",
                                    onClick: ($event: any) => (_ctx.editClick(element.id))
                                  }, _hoisted_26, 8, _hoisted_23)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ], 64))
    ]),
    _createVNode(_component_PaginateComponent, {
      "page-size": _ctx.page.size,
      amount: _ctx.filter.amount,
      total: _ctx.filter.total,
      onCurrentPageChange: _ctx.selectedPage
    }, null, 8, ["page-size", "amount", "total", "onCurrentPageChange"])
  ], 64))
}